
export enum AsyncComponentPriceEnum {

    Price = 'Price',
    PriceTabs = 'PriceTabs',
    PriceGroupMeasureTabs = 'PriceGroupMeasureTabs',
    PriceMeasureMutateForm = 'PriceMeasureMutateForm',
    PriceGroupMeasureListForm = 'PriceGroupMeasureListForm',
    PriceGroupMeasureMutateForm = 'PriceGroupMeasureMutateForm',
    PriceMeasureMutate = 'PriceMeasureMutate',
    PriceMeasureMutateListForm = 'PriceMeasureMutateListForm',
    PriceMeasureMutateList = 'PriceMeasureMutateList',
    PriceGroupMeasureMutate = 'PriceGroupMeasureMutate',
    PriceMeasureListForm = 'PriceMeasureListForm',
    PriceMeasureList = 'PriceMeasureList',
    ProductModelOptionalPriceGroupMeasureMutate = 'ProductModelOptionalPriceGroupMeasureMutate',
    ProductModelOptionalPriceGroupMeasureMutateForm = 'ProductModelOptionalPriceGroupMeasureMutateForm'


}

export const priceComponents = {
    [ AsyncComponentPriceEnum.Price ]: () => import( '@/views/price/priceList/PriceList.vue' ),
    [ AsyncComponentPriceEnum.PriceTabs ]: () => import( '@/components/price/PriceTabs.vue' ),
    [ AsyncComponentPriceEnum.PriceGroupMeasureTabs ]: () => import( '@/components/price/PriceGroupMeasureTabs.vue' ),
    [ AsyncComponentPriceEnum.PriceMeasureMutateForm ]: () => import( '@/components/price/PriceMeasureMutateForm.vue' ),
    [ AsyncComponentPriceEnum.PriceGroupMeasureListForm ]: () => import( '@/components/price/PriceGroupMeasureListForm.vue' ),
    [ AsyncComponentPriceEnum.PriceGroupMeasureMutateForm ]: () => import( '@/components/price/PriceGroupMeasureMutateForm.vue' ),
    [ AsyncComponentPriceEnum.PriceMeasureMutate ]: () => import( '@/views/price/priceMeasureMutate/PriceMeasureMutate.vue' ),
    [ AsyncComponentPriceEnum.PriceGroupMeasureMutate ]: () => import( '@/views/price/priceGroupMeasureMutate/PriceGroupMeasureMutate.vue' ),
    [ AsyncComponentPriceEnum.PriceMeasureListForm ]: () => import( '@/components/price/PriceMeasureListForm.vue' ),
    [ AsyncComponentPriceEnum.PriceMeasureList ]: () => import( '@/views/price/priceMeasureList/PriceMeasureList.vue' ),
    [ AsyncComponentPriceEnum.ProductModelOptionalPriceGroupMeasureMutate ]: () => import( '@/views/price/productModelOptionalPriceGroupMeasureMutate/ProductModelOptionalPriceGroupMeasureMutate.vue' ),
    [ AsyncComponentPriceEnum.ProductModelOptionalPriceGroupMeasureMutateForm ]: () => import( '@/components/price/ProductModelOptionalPriceGroupMeasureMutateForm.vue' ),
    [ AsyncComponentPriceEnum.PriceMeasureMutateListForm ]: () => import( '@/components/price/PriceMeasureMutateListForm.vue' ),
    [ AsyncComponentPriceEnum.PriceMeasureMutateList ]: () => import( '@/views/price/priceMeasureMutateList/PriceMeasureMutateList.vue' ),
}
